import { FEATURE_CONFIG_NAMESPACES } from '@/constants/featureConfig'
import { firestore } from '@/plugins/firebase'
import { collection, query, where, getDocs } from 'firebase/firestore'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFeatureConfigs = async (store: any) => {
  const q = query(
    collection(firestore, 'feature_configs'),
    where('namespace', 'in', FEATURE_CONFIG_NAMESPACES)
  )
  const querySnapshot = await getDocs(q)

  store.commit('setFeatureConfigs', querySnapshot.docs)
}

export default {
  getFeatureConfigs
}
